import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["question", "isSkipped", "answer", "label", "index", "isCorrect", "submitGradeAnswer", "disabled", "hasAnswer", "updatedAnswerId", "isPreviewMode", "isShowingExplanation", "isSubmissionSubmitted"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Space, Col, Row, Tooltip } from 'antd';
import { SingleSelectInput, styleVariables } from '@lib/common';
import { GradingBaseAnswer } from './base-question.component';
import { ScoreInput } from '../score-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n"])));
var StyledAnswerRow = styled(Row)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledQuestionDescriptionWrapper = styled(Col)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var StyledQuestionIndex = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  min-width: 32px;\n  text-align: center;\n"])));
var StyledQuestionDescription = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-left: 8px;\n  font-size: 16px;\n"])));
var StyledSelectInputCol = styled(Col)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"])));
var StyledCorrectAnswerText = styled.label(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-width: 80px;\n  flex-shrink: 0;\n  text-align: left;\n  font-weight: ", ";\n  color: ", ";\n"])), styleVariables.font.fontWeightStrong, function (props) {
  if (props.$warning) return styleVariables.colors.gold1;
  if (props.$error) return props.theme.color.fontColorError;
  return props.theme.color.fontColorSuccess;
});
var StyledScoreInputContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 1px;\n  flex-shrink: 0;\n"])));

var roundNumber = function roundNumber(number) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
};

var calculateTotalScore = function calculateTotalScore(answers) {
  var allNotGraded = answers.every(function (answer) {
    return !answer.hasGraded();
  });

  if (allNotGraded) {
    return null;
  }

  return answers.reduce(function (total, answer) {
    if (!answer.hasGraded()) {
      return total;
    }

    return roundNumber(total + answer.score);
  }, 0);
};

var areAllSubQuestionsGraded = function areAllSubQuestionsGraded(answers) {
  return answers.every(function (answer) {
    return answer.score !== SubmissionScore["default"].value;
  });
};

var getScoreInputValue = function getScoreInputValue(score) {
  return score !== SubmissionScore["default"].value ? score : null;
};

var getSavedAnswerId = function getSavedAnswerId(matchingGroupAnswer, subQuestionId) {
  var _matchingGroupAnswer$, _matchingGroupAnswer$2, _matchingGroupAnswer$3;

  return matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : (_matchingGroupAnswer$ = matchingGroupAnswer.answers) === null || _matchingGroupAnswer$ === void 0 ? void 0 : (_matchingGroupAnswer$2 = _matchingGroupAnswer$.find(function (a) {
    return a.subQuestionId === subQuestionId;
  })) === null || _matchingGroupAnswer$2 === void 0 ? void 0 : (_matchingGroupAnswer$3 = _matchingGroupAnswer$2.value) === null || _matchingGroupAnswer$3 === void 0 ? void 0 : _matchingGroupAnswer$3.answerId;
};

export var GradingMatchingAnswer = function GradingMatchingAnswer(_ref) {
  var question = _ref.question,
      isSkipped = _ref.isSkipped,
      matchingGroupAnswer = _ref.answer,
      label = _ref.label,
      index = _ref.index,
      isCorrect = _ref.isCorrect,
      submitGradeAnswer = _ref.submitGradeAnswer,
      disabled = _ref.disabled,
      hasAnswer = _ref.hasAnswer,
      updatedAnswerId = _ref.updatedAnswerId,
      isPreviewMode = _ref.isPreviewMode,
      isShowingExplanation = _ref.isShowingExplanation,
      isSubmissionSubmitted = _ref.isSubmissionSubmitted,
      rest = _objectWithoutProperties(_ref, _excluded);

  var totalScore = useMemo(function () {
    return calculateTotalScore(matchingGroupAnswer.answers);
  }, [matchingGroupAnswer.answers]);
  var isAllSubQuestionAnswerGraded = useMemo(function () {
    return areAllSubQuestionsGraded(matchingGroupAnswer.answers);
  }, [matchingGroupAnswer.answers]);
  var answerOptions = useMemo(function () {
    return question.answers.map(function (a) {
      return {
        value: a.id.toString(),
        label: a.description
      };
    });
  }, [question.answers]);

  var renderScoreInput = function renderScoreInput(answeredSubQuestion, correctAnswer, submitAnswerScore) {
    var scoreValue = getScoreInputValue(answeredSubQuestion.score);
    var isGraded = answeredSubQuestion.hasGraded();
    var isDisabled = disabled || updatedAnswerId === answeredSubQuestion.id.toString();

    var scoreInput = /*#__PURE__*/_jsx(StyledScoreInputContainer, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: correctAnswer.score,
        label: label,
        submitScore: submitAnswerScore,
        value: scoreValue,
        disabled: isPreviewMode || isDisabled,
        active: isGraded,
        danger: isGraded && answeredSubQuestion.score === 0
      })
    });

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.disabledScoreInputText,
        children: scoreInput
      });
    }

    return scoreInput;
  };

  var renderAnswers = function renderAnswers() {
    return question.subQuestions.map(function (subQ, index) {
      var _question$answers$fin;

      var answeredSubQuestion = matchingGroupAnswer.answers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });
      var correctAnswer = question.correctAnswers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });

      if (!answeredSubQuestion) {
        return null;
      }

      var correctAnswerDescription = (_question$answers$fin = question.answers.find(function (a) {
        return a.id.toString() === correctAnswer.answerId;
      })) === null || _question$answers$fin === void 0 ? void 0 : _question$answers$fin.description;

      var submitAnswerScore = function submitAnswerScore(score) {
        submitGradeAnswer(score, answeredSubQuestion.id.toString());
      };

      var savedAnswerId = getSavedAnswerId(matchingGroupAnswer, subQ.id.toString());

      var renderAnswerStatus = function renderAnswerStatus() {
        var _answeredSubQuestion$;

        if (!answeredSubQuestion.value) {
          if (!isSubmissionSubmitted) {
            return null;
          }

          return /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
            $error: true,
            children: ["(", label.skipped, ")"]
          });
        }

        var isAnswerCorrect = question.isCorrect(answeredSubQuestion.subQuestionId, (_answeredSubQuestion$ = answeredSubQuestion.value) === null || _answeredSubQuestion$ === void 0 ? void 0 : _answeredSubQuestion$.answerId);
        var isManuallyAwarded = !isAnswerCorrect && answeredSubQuestion.hasGraded() && typeof answeredSubQuestion.score === 'number' && answeredSubQuestion.score > 0;
        return /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
          $error: !isAnswerCorrect && !isManuallyAwarded,
          $warning: isManuallyAwarded,
          children: ["(", isAnswerCorrect ? label["true"] : label["false"], ")"]
        });
      };

      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(StyledAnswerItem, {
          children: [/*#__PURE__*/_jsxs(StyledAnswerRow, {
            children: [/*#__PURE__*/_jsxs(StyledQuestionDescriptionWrapper, {
              span: 13,
              children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
                children: ["(", index + question.index, ")"]
              }), /*#__PURE__*/_jsx(StyledQuestionDescription, {
                children: subQ.description
              })]
            }), /*#__PURE__*/_jsx(StyledSelectInputCol, {
              span: 8,
              children: /*#__PURE__*/_jsx(SingleSelectInput, {
                defaultValue: savedAnswerId ? [savedAnswerId] : [],
                disabled: true,
                options: answerOptions
              })
            })]
          }), renderAnswerStatus(), (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.score) && renderScoreInput(answeredSubQuestion, correctAnswer, submitAnswerScore)]
        }), correctAnswerDescription && /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 12,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              children: ["(", label.correctAnswer, ": ", correctAnswerDescription, ")"]
            })
          })
        })]
      }, subQ.id.toString());
    });
  };

  return /*#__PURE__*/_jsx(GradingBaseAnswer, _objectSpread(_objectSpread({}, rest), {}, {
    question: question,
    isSkipped: isSkipped,
    isCorrect: isCorrect,
    hasAnswer: hasAnswer,
    label: label,
    index: index,
    submitGradeAnswer: submitGradeAnswer,
    disabled: disabled,
    value: totalScore,
    isResponderView: isPreviewMode,
    isEssayQuestion: true,
    isAllQuestionAnswersGraded: isAllSubQuestionAnswerGraded,
    isShowingExplanation: isShowingExplanation,
    children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  }));
};